export function noOptionsMessage(e, messageEmptyList,length,messageNoChars) {
  if(e && e.inputValue.length > (length || 0)){
      return messageEmptyList
  }else{
      return messageNoChars || 'Comece a digitar' 
  }
}

